import { Descriptions, Typography } from "antd";
import dayjs from "dayjs";
import { toDollars } from "helpers";

function CreditCardInfo({ data }) {
  const isVirtualCard = data.virtual_card?.cardNumber;
  const ccDetails = isVirtualCard ? data.virtual_card : data.creditCard;
  const isAmex = ccDetails.cardNumber.length === 15;
  // format card number
  const cardNumber = isAmex
    ? ccDetails.cardNumber.replace(/(\d{4})(\d{6})(\d{4})/, "$1 $2 $3")
    : ccDetails.cardNumber.match(/.{1,4}/g).join(" ");
  return (
    <div
      style={{
        position: "relative",
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `linear-gradient(
          to right,
          rgba(156, 156, 156, 0.8),
          rgba(28, 255, 179, 0.849)
        ), url(../img/gazeebo.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "top",
      }}
    >
      <div
        className="logo-box"
        style={{ position: "absolute", top: 20, left: 20 }}
      >
        <img src="/img/logo-white.png" alt="Logo" className="logo" />
      </div>

      <div
        style={{
          backgroundColor: "white",
          padding: 24,
          borderRadius: "12px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
          maxWidth: 400,
          width: "100%",
        }}
      >
        <Typography.Title level={4} style={{ margin: 0 }}>
          Credit Card Authorization
        </Typography.Title>
        <Descriptions
          column={1}
          layout="horizontal"
          size="middle"
          style={{ marginTop: 16 }}
        >
          <Descriptions.Item label="Card Number">
            {cardNumber}
          </Descriptions.Item>
          <Descriptions.Item label="Expiration">
            {dayjs(ccDetails.valid_thru).format("MM/YY")}
          </Descriptions.Item>
          <Descriptions.Item label="Security Code">
            {ccDetails.securityCode}
          </Descriptions.Item>
          <Descriptions.Item label="Zip Code">
            {ccDetails.billing_zipcode}
          </Descriptions.Item>
          <Descriptions.Item label="Amount">
            {toDollars(data.amount)}
          </Descriptions.Item>
        </Descriptions>
      </div>
    </div>
  );
}

export default CreditCardInfo;
